import { useEffect } from 'react'
import { makeSocket } from 'src/lib/socket'
import Cookie from 'js-cookie'
import config from 'config'

export const useInitSocket = () => {
  const initScoket = () => {
    const userHasSession = Cookie.get(config.NEXT_PUBLIC_COOKIE_NAME)
    makeSocket(userHasSession)
  }
  useEffect(() => {
    initScoket()
  }, [])
}
